<template>
  <div>
    <v-layout row>
      <!-- <v-flex xs8></v-flex> -->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="fetching_log"
      :items="promotion_log_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ promotion_log_list.indexOf(props.item)+1}}</td>
        <td class="text-xs-center">{{ props.item.use_pro_code }}</td>
        <td class="text-xs-center">{{ props.item.use_pro_user_id }}</td>
        <td class="text-xs-center">{{ props.item.use_pro_user_fullname }}</td>
        <td class="text-xs-center">{{ props.item.use_pro_price }}</td>
        <td class="text-xs-center">{{ props.item.use_pro_date }}</td>
        <td class="text-xs-center">{{ props.item.use_pro_time }}</td>
      </template>

      <template slot="no-data" class="text-xs-center">
        <center>
          <label v-if="fetching_log==true">Loading ...</label>
          <label v-if="fetching_log==false">
            No data available <br>
            <v-btn @click="initialize()">Reset</v-btn>
          </label>
        </center>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page"></v-pagination>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      fetching_log: false,
      search: "",
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      headers: [
        {
          text: "#",
          align: "center",
          sortable: false,
          value: "num"
        },
        {
          text: "Promotion code",
          align: "center",
          value: "use_pro_code",
          sortable: false
        },
        {
          text: "User ID",
          align: "center",
          value: "use_pro_user_id",
          sortable: false
        },
        {
          text: "Customer name",
          align: "center",
          value: "use_pro_user_fullname",
          sortable: false
        },
        {
          text: "Discount price",
          align: "center",
          value: "use_pro_price",
          sortable: false
        },
        {
          text: "Date",
          align: "center",
          value: "use_pro_date",
          sortable: false
        },
        {
          text: "Time",
          align: "center",
          value: "use_pro_time",
          sortable: false
        }
      ],
      useCode: [
        {
          num: 1,
          promotion_code: "WESTAFF2",
          used_status: "Available",
          customer_name: "วาโย เจ้าคับ",
          date: "2019/03/06",
          time: "16.59"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      promotion_log_list: state =>
        state.fetchFoodPromotionBack.promotion_use_log
    })
  },
  methods: {
    async initialize() {
      this.fetching_log = true;
      await this.$store.dispatch(
        "fetchFoodPromotionBack/getPromotionLog",
        this.$route.params.promotionid
      );
      this.fetching_log = false;
    }
  },
  async created() {
    this.initialize();
  }
};
</script>

<style>
</style>
